import CollectionEditor from "./CollectionEditor"

export const SideContent = CollectionEditor
